import React, { JSX } from 'react'
import { PiDotsThreeCircleVerticalLight } from 'react-icons/pi'

import { PatientProfile } from '../api/services/orders/types.ts'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: PatientProfile) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
  sortDirection?: 'asc' | 'desc'
}

export const setPatientProfileTableColumns = () => {
  const columns: TableColumn[] = [
    {
      header: 'Imię i nazwisko',
      accessor: 'last_name',
      render: (row: PatientProfile) => (
        <p className={'text-xm'}>{`${row.first_name} ${row.last_name}`}</p>
      ),
      className: 'w-[150px] 2xl:w-auto',
      sorted: true,
      sortDirection: 'asc'
    },
    {
      header: 'Płeć',
      accessor: 'sex',
      render: (row: PatientProfile) => (
        <p className={'text-xm'}>{row.sex === 1 ? 'M' : 'K'}</p>
      ),
      className: 'w-[80px] 2xl:w-auto'
    },
    {
      header: 'Grupa',
      accessor: 'patient_type',
      render: (row: PatientProfile) => (
        <p className={'text-xm'}>{row.patient_type}</p>
      ),
      className: 'w-[120px] 2xl:w-auto'
    },
    {
      header: 'Pacjent z PD3',
      accessor: 'pd3_uuid',
      render: (row: PatientProfile) => (
        <p className={'text-xm'}>{row.pd3_uuid ? 'Tak' : 'Nie'}</p>
      ),
      className: 'w-[100px] 2xl:w-auto'
    }
  ]

  return columns
}

export const setPatientProfileTableActions = (
  onOpenMenu: (
    row: PatientProfile,
    event: React.MouseEvent<HTMLButtonElement>
  ) => void
) => {
  return [
    {
      label: '',
      icon: <PiDotsThreeCircleVerticalLight size={30} />,
      onClick: (
        row: PatientProfile,
        event: React.MouseEvent<HTMLButtonElement>
      ) => {
        onOpenMenu(row, event)
      },
      className: 'text-blue-500 pb-1'
    }
  ]
}
